import { IField } from "../interfaces/inputs/IField";

const terms = [
  {value: 'I', text: 'I'},
  {value: 'II', text: 'II'},
  {value: 'III', text: 'III'}
]

export const TenantFields: IField[] = [
  { name: "name", type: "text", label: "Product Name", size: {lg: 6}, position: 1 },
  { name: "term", type: "select", label: "Term", options: terms, position: 2, size: {lg: 4} },
  { name: "year", type: "number", label: "Year", size: {lg: 4}, position: 3 },
  { name: "signature", type: "file", label: "Signature", position: 4, size: {lg: 6} }
].sort((a: IField, b: IField) => a.position - b.position);